<template>
    <div class="w-100 text-right">
        <div class="list-group mb-3 overflow-scroll">
            <div class="card list-group-item" v-for="file in files" :key="file.id">
                <h6 class="card-title">{{file.path}}</h6>
                <div class="card-body">
                    <p class="card-text" v-if="file.last_scanned">
                    <span>last scanned</span>{{file.last_scanned}}
                    </p>
                    <span v-if="file.annotated">OCR処理済み</span>
                    <span v-else>OCR処理中</span>
                </div>
            </div>
        </div>
        <button type="button" class="btn btn-primary" @click="toggle" v-if=!fileupload>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-arrow-up" viewBox="0 0 16 16">
                <path d="M8 11a.5.5 0 0 0 .5-.5V6.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 6.707V10.5a.5.5 0 0 0 .5.5z"/>
                <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
            </svg>
            ファイルの追加
        </button>
        <div v-if="fileupload" class="mt-3 p-3 position-relative">
            <FileUpload :bucketname="bucketname" :prefix="prefix" @upload-finished="uploadFinished($event)"/>
            <button type="button" class="btn btn-secondary position-absolute top-0 end-0" @click="toggle">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                    <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                </svg>
            </button>
        </div>
        <button type="button" class="btn btn-primary ms-1" @click="startScan" :disabled="notReadyForScan">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
            </svg>
            参照解析
        </button>
        <button type="button" class="btn btn-primary" @click="updateFileList()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
            </svg>
        </button>
    </div>
</template>

<script>
import utils from "../utils/utils"
import FileUpload from "../components/FileUpload";
export default {
    name: "FileListPanel",
    components: {
        FileUpload
    },
    props: {
        lawcaseId: {type:Number, required: true},
        bucketname: {type:String, required: true},
        prefix: {type:String, required: true},
    },
    data() {
        return {
            files: [],
            fileupload: false,
            processing: false
        }
    },
    async mounted() {
        //await this.updateFileList(this.lawcaseName);
    },
    methods: {
        async updateFileList(lawcaseId){
            if(!lawcaseId){ lawcaseId = this.lawcaseId; }
            console.log(lawcaseId)
            console.log(this.lawcaseId)
            console.log(`TRYING TO LOAD FILELIST of ${name}`);
            try{
                this.files = await utils.get(`/api/files/${lawcaseId}`);
            } catch(err) {
                this.$emit('scan-finished', false);
                throw err;
            }
        },
        async startScan() {
            document.body.style.cursor="wait";
            this.processing = true;

            try{
                let res = await utils.post(`/api/scan/${this.lawcaseId}`);
                this.$emit('scan-finished', true);
                if(res['result'] !== 'OK'){
                    throw "スキャンに失敗しました";
                }
            } finally {
                this.processing = false;
                document.body.style.cursor="auto";
            }
        },
        toggle() {
            this.fileupload = !this.fileupload;
        },
        async uploadFinished(n_cases) {
            console.log("UPDATE FINISHED " + n_cases);
            this.fileupload = false;
            await this.updateFileList();
        }
    },
    computed: {
        notReadyForScan: function() {
            return this.processing || this.files.length == 0 || this.files.some( (f) => { !f.annotated; } );
        }
    },
    watch: {
        async lawcaseId(newVal) {
            if(newVal){
                await this.updateFileList(newVal)
            } else {
                this.files = [];
            }
        }
    }
}
</script>
<style scoped>
.overflow-scroll {
    max-height: 500px;
}
</style>

